module.exports = __webpack_public_path__ + "img/wealth-rule.377a8bdc.png";